<template>
  <component :is="dashboardComponent" />
</template>

<script>
import DashboardLegacy from './DashboardLegacy.vue';
import DashboardNew from './DashboardNew.vue';
import { getUserSetting } from '@/utils/userSettings';

export default {
  name: 'Dashboard',
  components: {
    DashboardLegacy,
    DashboardNew
  },
  computed: {
    dashboardComponent() {
      // Feature flag: when true, use the old/legacy dashboard layout.
      // Setting is read from localStorage via the userSettings utility.
      return getUserSetting('useOldDashboard', false) ? 'DashboardLegacy' : 'DashboardNew';
    }
  }
}
</script>
